import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component } from '@angular/core';
@Component({
  selector: 'ng-cheques-cheque-entry-popover',
  templateUrl: './cheque-entry-menu.component.html',
  styleUrls: ['./cheque-entry-menu.component.styl']
})
export class ChequeEntryMenuComponent {
  constructor(
    public sql: SQLService,
    public popover: PopoverController) {
  }
  dismissPopover(e) {if (this.popover) this.popover.dismiss(e);}
  delete() {this.dismissPopover('delete');}
  print() {this.dismissPopover('print');}
}